<template>
    <b-overlay  rounded="sm">
        <div class="card border-0 bg-wash no-shadow">
        
            <div class="card-header ">
                <div class="card-header-inner clearfix">
                    <div class="float-left align-self-center pt-1 col-sm-3 " style="font-size: 18px;">Total employees <span class="ml-2 people">{{people}}</span></div>
                    
                    <div class="float-left align-self-center col-sm-7 custom-search ">
                        <b-input-group >
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search by employee / position / branch / email / phone" v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>

                    <b-button  class="float-right employee-filter-btn col-sm-2" v-b-toggle.sidebar_right>Filter<b-icon class="ml-3" icon="funnel-fill" ></b-icon></b-button>
                    
                </div>
            </div>            
                    
            
            <div class="card-body container px-0">                
                <!-- list view starts here --> 
                <div class="wrapper2 mb-4" >   
                    <div class="div2">            
                        <table class="employee-list-table" >
                            <tbody>
                                <tr class="table-head">
                                    <td>Name</td>         
                                    <td>Job Position</td>
                                    <td>Department</td>                                    
                                    <td>Work Location</td>                                    
                                </tr>
                            
                                <tr class="hover-bg table-row cursor-pointer" v-for="employee in paginatedData" :key="employee.employee_id" @click="editEmployee(employee.employee_id,employee.name)">
                                    <td>                                        
                                        <label class="mb-0 custom-label">
                                            <img v-if="employee.pic != ''" v-bind:src="$api_url+'/public/images/employee/'+ employee.company_id + '/' + employee.pic" class="img-fluid img-thumbnail employee-avatar mx-2" />
                                            <img v-else v-bind:src="$api_url+'/public/images/employee/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mx-2" />
                                            <span >{{employee.name}}</span>
                                        </label>
                                    </td>                                                          
                                    <td>{{employee.jobposition}}</td>
                                    <td>{{employee.department}}</td>
                                    <td>{{employee.branch}}</td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- list view ends here -->
                
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">                
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="length" :options="length_options"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
                
                </div>
                <div class="row p-4 no-gutters justify-content-center align-items-center" v-if="paginatedData.length == 0">
                    <p class="mb-0 mr-3">{{blankmsg}}</p>
                </div>
            </div>



            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <template v-slot:default="{ hide }">
                    <div class="px-3 py-2">
                    
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="person-fill"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Name.." v-model="search_group.name" @input="setSearch()"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="envelope"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="email" placeholder="eMail.." v-model="search_group.email" @input="setSearch()"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="phone"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Mobile Number.." v-model="search_group.phone" @input="setSearch()"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="department_id" class='form-control' v-model='search_by_id.department_id' @change="setSearch()">
                                <option value='0' >Select Department</option>
                                <option v-for='data in depertments' :value='data.id'>{{ data.name }}</option>
                            </select>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list-ul"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="jobposition_id" class='form-control' v-model='search_by_id.jobposition_id' @change="setSearch()">
                                <option value='0' >Select Job Position</option>
                                <option v-for='data in jobtypes' :value='data.id'>{{ data.name }}</option>
                            </select>
                        </b-input-group>

                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="house"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="branch_id" class='form-control' v-model='search_by_id.branch_id' @change="setSearch()">
                                <option value='0' >Select Work Location</option>
                                <option v-for='data in branches' :value='data.id'>{{ data.name }}</option>
                            </select>
                        </b-input-group>

                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="house"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="status" class='form-control' v-model='search_by_id.status' @change="setSearch()">
                                <option value='0' >Select Status</option>
                                <option value='1' >Active</option>
                                <option value='-1' >Inactive</option>
                                <option value='2' >Leaver</option>
                                <option value='3' >Ex</option>
                                
                            </select>
                        </b-input-group>

                        <div class="mt-4" >
                            <b-button variant="outline-secondary" block  title="Clear Filter" @click="resetFlter();"><div block @click="hide">Clear Filter</div></b-button>
                        </div>
                    </div>
                </template>
            </b-sidebar>
        
        </div>
    </b-overlay>
</template>


<script>
    export default{
        props: ['pageurl'],        
        
        data(){
            return {
                
                cu:window.location.href,
                ce:false,
                employees : [],                
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group:{name:'', email:'', phone:'' },
                search_by_id:{department_id:0, jobposition_id:0 , branch_id:0 , status:0},
                
                               
                
                showoverlay : true,

                notice: "Looks like you have not added any employee yet.",
                blankmsg : 'Fetching data..',
                people:0,

                depertments:[],
                jobtypes:[],
                branches:[],
                manager:[],
                leave_policies : [],
                pgurl:this.$api_url,

                search:'',
                length: 20,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
            }
        },
        methods:{            

            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            }, 
            resetFlter: function()
            { 
                this.pagination.currentPage = 1;
                this.search_group.name = '';
                this.search_group.email = '';
                this.search_group.phone = '';
                this.search_by_id.department_id = 0;
                this.search_by_id.jobposition_id = 0;
                this.search_by_id.branch_id = 0;
                //this.jobtypes = [];
                this.getEmployees();
            },
            setDepartment: function(pageflg)
            {
                this.pagination.currentPage = 1;
                this.search_by_id.jobposition_id = 0; 
                this.getJobTypes();
                this.getEmployees();
            },
            setSearch: function(pageflg)
            {
                this.pagination.currentPage = 1;
                this.getEmployees();
            },
            setPagination: function(pageflg)
            {                
                if(pageflg)
                    this.pagination.currentPage = this.pagination.nextPage;
                else    
                    this.pagination.currentPage = this.pagination.prevPage;
                
                this.getEmployees();
            },
            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;

                axios.get(this.$api_url+'/gf/employee/list' , {
                    params: {
                        page: this.pagination.currentPage,
                        //per_page: this.per_page,
                        search_query: this.search_group,
                        search_query_by_id: this.search_by_id,
                    }
                    }).then(function(response){
                        
                        this.showoverlay = false;
                        
                        if(response.data.error == 1) 
                            this.notice = response.data.notice;
                        else
                        {
                            this.employees = response.data.employee_data;
                            console.log(this.employees);

                            if(this.employees.length == 0)
                                this.blankmsg = "Looks like there is no employee eligible for GF Loan.";
                            else
                            {
                                this.length_options = [{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" }, 
                                                    { value: this.employees.length, text: "All" }
                                                ]; 
                                this.people = this.employees.length;
                            }
                                
                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            getDepertments: function(){
              axios.get(this.$api_url+'/department/list')
              .then(function (response) {
                 this.depertments = response.data;
              }.bind(this));
         
            },
            getJobTypes: function() {
                axios.get(this.$api_url+'/jobposition/options',{
                 params: {
                   
                 }
              }).then(function(response){
                    this.jobtypes = response.data;
                }.bind(this));
            },
            getBranches: function(){
              axios.get(this.$api_url+'/branch/list')
              .then(function (response) {
                 this.branches = response.data;
              }.bind(this));
         
            },
            editEmployee:function(x,name)
            {    
                if(!this.checkNet()) return false;
                
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response) 
                    {   let data = [];
                        data['id'] = x;
                        data['name'] = name;
                        
                        setTimeout(function () { this.$emit('childToParent' , data); }.bind(this), 1000);
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },    
        },
        created: function(){
                        

            this.getAcl();            
            this.getDepertments();
            this.getJobTypes();
            this.getBranches();
            this.getEmployees();
            
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.employees;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                       
                }

                this.people = filtered_list.length;
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            selectAll: {
                get: function () {
                    return this.employees ? this.selected.length == this.employees.length : false;
                },
                set: function (value) {
                    var selected = [];
                    if (value) {
                        this.employees.forEach(function (user) {
                            selected.push(user.employee_id);
                        });
                    } 
                    this.selected = selected;
                }
            }
        }
    }
</script>
<style>
button.disabled{
    cursor: default;
}

</style>